import { nl, type Dictionary } from "@/lib/i18n/nl";

/**
 * nl-NL is de default en enige launch-taal; extra talen betekenen later een
 * extra dictionary met dezelfde structuur plus een locale-switch hier.
 */
export function getDictionary(): Dictionary {
  return nl;
}

export const t = nl;
